import Link from "components/shared/Link";

const PhoneItem = ({ category = null }) => {
	const mainClass = "help-phone-item";
	const {
		webLinks = null,
		link = webLinks?.length ? webLinks[0] : null,
	} = category;

	return (
		<div className={`${mainClass}`} key={category.id}>
			<div className={`${mainClass}__title`}>{category.name}</div>
			{category?.phones?.map((number, index) => (
				<div
					className={`${mainClass}__number`}
					key={index}
					dangerouslySetInnerHTML={{ __html: number }}
				></div>
			))}
			{link && <Link className={`${mainClass}__link`} {...link} />}
		</div>
	);
};

export default PhoneItem;
